/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Infobox
 */
export interface Infobox {
  /**
   *
   * @type {number}
   * @memberof Infobox
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof Infobox
   */
  frontendId: string;
  /**
   *
   * @type {string}
   * @memberof Infobox
   */
  text: string;
}

/**
 * Check if a given object implements the Infobox interface.
 */
export function instanceOfInfobox(value: object): value is Infobox {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('frontendId' in value) || value['frontendId'] === undefined) return false;
  if (!('text' in value) || value['text'] === undefined) return false;
  return true;
}

export function InfoboxFromJSON(json: any): Infobox {
  return InfoboxFromJSONTyped(json, false);
}

export function InfoboxFromJSONTyped(json: any, ignoreDiscriminator: boolean): Infobox {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    frontendId: json['frontend_id'],
    text: json['text'],
  };
}

export function InfoboxToJSON(value?: Infobox | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    frontend_id: value['frontendId'],
    text: value['text'],
  };
}
